import styled from 'styled-components'

export const FormWrapper = styled.div`
    padding: 5px 1rem;
`
